import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineArrowDownIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M17.7099 11.29a.9998.9998 0 0 0-1.42 0l-3.29 3.3V7a.9997.9997 0 0 0-1-1 1.0001 1.0001 0 0 0-1 1v7.59l-3.29-3.3a1.0041 1.0041 0 1 0-1.42 1.42l5 5c.0951.091.2073.1624.33.21a.9403.9403 0 0 0 .76 0 1.0002 1.0002 0 0 0 .33-.21l5-5a.9987.9987 0 0 0 .2958-.71.9997.9997 0 0 0-.2958-.71Z"/>
  </SvgIcon>
}

export default LineArrowDownIcon
